import React from 'react';
import { CompassIcon } from 'lucide-react';
import { mapAnatomy, systemAnswers } from '../data/content';
export function SystemSection() {
  return <section className="border-y border-night-line bg-night" data-id="element-213" data-mp="3girifijomq2i">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" style={{
      paddingTop: "27px"
    }} data-id="element-214" data-mp="3bhtzh3qulrzy">
        <div className="mx-auto max-w-2xl text-center" data-id="element-215" data-mp="36j0k15s03qx5">
          <CompassIcon className="mx-auto h-8 w-8 text-gold-soft" aria-hidden="true" data-id="element-216" data-mp="31kpdb3x05wj5" />
          <h2 className="mt-5 font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
          fontSize: "32px"
        }} data-id="element-217" data-mp="31mjz0kg3lsoa">
            Tu GPS para recorrer toda la Biblia
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-218" data-mp="2ntkeu55dfaae">
            73 mapas visuales. Uno para cada libro de la Biblia Católica. Cada mapa te da
            una visión general antes o durante la lectura.
          </p>
        </div>

        <ol className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-219" data-mp="2dx7pfjguzilg">
          {systemAnswers.map(item => <li key={item.letter} className="rounded-2xl border border-night-line bg-night-panel p-6" data-id="element-220" data-mp="13xn0nd6oqrow">
              <div className="flex items-baseline gap-3" data-id="element-221" data-mp="18r96aleflvb7">
                <span aria-hidden="true" className="font-display text-4xl font-semibold leading-none text-gold" data-id="element-222" data-mp="u1tinea765zq">
                  {item.letter}
                </span>
                <h3 className="font-display text-xl font-semibold leading-snug text-gold-soft" style={{
              fontSize: "28px"
            }} data-id="element-223" data-mp="1mppnx7du1684">
                  {item.label}
                </h3>
              </div>
              <p className="mt-3 font-sans text-[0.95rem] leading-relaxed text-parchment/70" data-id="element-224" data-mp="1crrywho5f5eg">
                {item.description}
              </p>
            </li>)}
        </ol>

        <div className="mx-auto mt-16 max-w-2xl text-center lg:mt-24" data-id="element-225" data-mp="1hsfs99zunybu">
          <h3 className="font-display text-[1.7rem] font-semibold leading-tight text-parchment sm:text-4xl" data-id="element-226" data-mp="1atf14fs348l">
            {mapAnatomy.title}
          </h3>
          <p className="mx-auto mt-4 max-w-xl font-sans text-base leading-relaxed text-parchment/70 sm:text-lg" data-id="element-227" data-mp="28ymoh90t2n76">
            {mapAnatomy.description}
          </p>
        </div>

        <img src={mapAnatomy.image} alt={mapAnatomy.imageAlt} className="-mx-3 mt-8 block h-auto w-[calc(100%+1.5rem)] max-w-none sm:mx-auto sm:mt-10 sm:w-full sm:max-w-3xl" data-id="element-228" data-mp="1z8bkxnl1ag0t" />
      </div>
    </section>;
}